import Typography from '@components/v2/ui/Typography/Typography';
import { Stack } from '@mui/material';
import useMoney from '../../../../../hooks/useMoney';
import LangEnum from '../../../../../lang/LangEnum';
import { ErrorsWithQuantities } from '../../../../../services/modules/order-product/order-product.types';
import { useTranslation } from '../../../../translation/TranslationContext';
import { BusinessPolicyViolationView } from '../../../edit/validate/conditions/businessPolicy/businessPolicyViolation.types';
import BusinessPolicyViolationSummary from '../../../edit/validate/conditions/businessPolicy/components/BusinessPolicyViolationSummary';

interface OrderProductsErrorsTooltipContentProps {
  errors: ErrorsWithQuantities;
  policyViolations: BusinessPolicyViolationView[];
  onOpenDetails?: () => void;
}

const OrderProductsErrorsTooltipContent = ({
  errors,
  policyViolations,
  onOpenDetails,
}: OrderProductsErrorsTooltipContentProps) => {
  const { translate } = useTranslation();
  const { getCurrencySymbol } = useMoney();

  const errorEntries = Object.entries(errors);

  return (
    <Stack sx={{ gap: 1.5, maxWidth: 400 }}>
      {!!errorEntries.length && (
        <Stack sx={{ gap: 1 }}>
          <Typography variant="subtitle2" color="inherit">
            {translate(LangEnum.ORDER_VALIDATION_REGISTRATION_PENDING)}
          </Typography>

          <Stack sx={{ gap: 0.5 }}>
            {errorEntries.map(([messageCode, quantity], index) => (
              <Typography key={messageCode} variant="body2" color="inherit">
                {index + 1}.{' '}
                {translate(messageCode as LangEnum, {
                  messageByItem: false,
                  quantity,
                  currency: getCurrencySymbol(),
                })}
              </Typography>
            ))}
          </Stack>
        </Stack>
      )}

      {!!policyViolations.length && (
        <Stack sx={{ gap: 1 }}>
          <Typography variant="subtitle2" color="inherit">
            {translate(LangEnum.ORDER_VALIDATION_POLICY_PENDING)}
          </Typography>
          <BusinessPolicyViolationSummary
            violations={policyViolations}
            onOpenDetails={onOpenDetails}
          />
        </Stack>
      )}
    </Stack>
  );
};

export default OrderProductsErrorsTooltipContent;
